import country from './jsonData/country.json'
import districts from './jsonData/districts.json'
import state from './jsonData/state.json'
import timezone from './jsonData/time-zone-service.json'


export const getRules = (name) => {
  if (name && name.toLowerCase() == 'email') {
    return [
      (value) => !!value || "E-mail is required.",
      (value) => {
        if (/.+@.+\..+/.test(value)) {
          return true;
        }
        return "E-mail must be valid.";
      },
    ]
  }
  return [(value) => value !== null && value !== undefined && value !== '' || `${name} is required.`];
}

export const allowOnlyNumbers = (event) => {
  const allowedKeys = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Home",
    "End",
  ];

  if (
    (event.key >= "0" && event.key <= "9") ||
    allowedKeys.includes(event.key)
  ) {
    return;
  } else {
    event.preventDefault();
  }
};

export const getGeographicData = (key, code) => {
  if (key === 'country') {
    return country;  // Return country list
  } else if (key === 'state' && code) {
    return state[code] || [];  // Return states for the given country code, or empty if not found
  } else if (key === 'districts' && code) {
    return districts[code] || [];  // Return districts for the given state code, or empty if not found
  } else if (key === 'timezone') {
    return timezone || [];  // Return timezone list
  }
  return [];  // Return empty array for invalid or missing keys
};

export const formatData = (number, decimal) => {
  if (typeof number === 'number' && !isNaN(number) & typeof decimal === 'number' && !isNaN(decimal) && decimal >= 0) {
    const factor = Math.pow(10, decimal);
    const truncated = Math.trunc(number * factor) / factor;
    return truncated.toFixed(decimal);
  }
}